import Vue from 'vue'
import { Form, Button, Input, Select, Modal } from 'ant-design-vue'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'

import './css/index.less'

Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.use(Select)
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
